import { createRouter, createWebHashHistory } from 'vue-router'

const HomePage = () => import('@/pages/index')
const ProductPage = () => import('@/pages/Product')
const ServicePage = () => import('@/pages/Service')
const DataSetPage = () => import('@/pages/DataSet')
const ResourcePage = () => import('@/pages/Resource')
const ResourceArchivePage = () => import('@/pages/ResourceArchive')
const AboutPage = () => import('@/pages/About')
const DataSetDetailPage = () => import('@/pages/dataSetDetail/detail')

const routes = [
  {
    path: '/',
    name: 'index',
    component: HomePage,
    meta: {
      keepAlive: true,
      index: 1,
    },
  },
  {
    path: '/Product',
    name: 'Product',
    component: ProductPage,
  },
  {
    path: '/Service',
    name: 'Service',
    component: ServicePage,
  },
  {
    path: '/DataSet',
    name: 'DataSet',
    component: DataSetPage,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/Resource',
    name: 'Resource',
    component: ResourcePage,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/ResourceArchive',
    name: 'ResourceArchive',
    component: ResourceArchivePage,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
  },
  {
    path: '/dataSetDetail',
    name: 'dataSetDetail',
    component: DataSetDetailPage,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
